import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { BaseActions, BaseActionTypes } from './base.actions';
import { BaseEntity } from './base.model';

export interface BaseEntities extends EntityState<BaseEntity> {
  // additional entities state properties
}

export const adapter: EntityAdapter<BaseEntity> = createEntityAdapter<BaseEntity>();

export const initialState: BaseEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): BaseEntities {
  const action: BaseActions = incomingAction as BaseActions;
  switch (action.type) {
    case BaseActionTypes.AddBase: {
      return adapter.addOne(action.payload.base, state);
    }

    case BaseActionTypes.UpsertBase: {
      return adapter.upsertOne(action.payload.base, state);
    }

    case BaseActionTypes.AddBases: {
      return adapter.addMany(action.payload.bases, state);
    }

    case BaseActionTypes.UpsertBases: {
      return adapter.upsertMany(action.payload.bases, state);
    }

    case BaseActionTypes.UpdateBase: {
      return adapter.updateOne(action.payload.base, state);
    }

    case BaseActionTypes.UpdateBases: {
      return adapter.updateMany(action.payload.bases, state);
    }

    case BaseActionTypes.DeleteBase: {
      return adapter.removeOne(action.payload.id, state);
    }

    case BaseActionTypes.DeleteBases: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case BaseActionTypes.LoadBases: {
      return adapter.setAll(action.payload.bases, state);
    }

    case BaseActionTypes.ClearBases: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
